module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAFlUW0AAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAACKADAAQAAAABAAAADgAAAAAaxI7yAAAA5klEQVQYGWVROwrCQBDdDdZWdpZ2Yi8kAY/gBTyAYGlpn8IDWGjrCRRB0UbIr1jEylILsfAGKfLxzeJOVlyY5P2Smd0VYRheRb2UUi3Noii6iSRJ+rX3h5BZCjxG7IC8mNgAxllzgA5qZsjQTjlSynscxxNbFBDaqDmJ0jhpmjaLolgYLrARVVWVowV0eLAD8mYCIGlbZVlugKee561tkzA3oWHBT/jvyvf9wAQ5YAQ6tizL9pj/4rru+C9Awe/IW8Bnw3xJb9ogWhzzPN+hzYA0HUD/HvABFWDQLhm86OYQ+DlANgE+qntuYMQ3+hkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/page-component/page-component/right.png
// module id = bX7M
// module chunks = 35